import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetStatusCellRendererComponent } from './asset-status-cell-renderer.component';

@NgModule({
  declarations: [AssetStatusCellRendererComponent],
  imports: [CommonModule],
})
export class AssetStatusCellRendererModule {}
